import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPartialFull = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    aria-label="Partial_Full"
    {...props}
  >
    <circle cx={8} cy={8} r={8} fill="url(#Partial_Full_svg__a)" />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M12.33 4.727a.777.777 0 0 1 0 1.099l-5.29 5.291c-.42.42-1.101.423-1.525.007L3.432 9.077A.776.776 0 1 1 4.521 7.97l1.75 1.72 4.962-4.963a.776.776 0 0 1 1.098 0"
      clipRule="evenodd"
    />
    <rect
      width={1.5}
      height={8.199}
      x={6}
      y={5.2}
      fill="#fff"
      fillOpacity={0.35}
      rx={0.75}
      transform="rotate(-45 6 5.2)"
    />
    <defs>
      <linearGradient
        id="Partial_Full_svg__a"
        x1={13}
        x2={-7}
        y1={11.75}
        y2={11.333}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F1B209" />
        <stop offset={1} stopColor="#FCDB35" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgPartialFull;
